import { render, staticRenderFns } from "./PicklistField.vue?vue&type=template&id=2b1950c8&"
import script from "./PicklistField.vue?vue&type=script&lang=js&"
export * from "./PicklistField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports